import { Locales } from "types/localization";

interface Props {
  path?: string;
}

export const getHreflang = (props: Props) => {
  const { path } = props;

  if (!path) {
    return [];
  }

  return [
    ...Object.keys(Locales).map((key) => {
      const urlLocale = key === "en" ? "" : `/${key}`;
      return {
        rel: "alternate",
        hrefLang: Locales[key],
        href: `${window.location.origin}${urlLocale}${path}`,
      };
    }),
    {
      rel: "alternate",
      hrefLang: "x-default",
      href: `${window.location.origin}${path}`,
    },
  ];
};
